// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const PPTExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect width={36} height={36} rx={8} fill="#D2593C" />
				<path
					opacity={0.9}
					d="M13.7251 11.9805H18.4233C19.3198 11.9805 20.0918 12.152 20.7393 12.4951C21.3923 12.8327 21.8875 13.3086 22.2251 13.9229C22.5627 14.5371 22.7314 15.2427 22.7314 16.0396C22.7314 16.842 22.5599 17.5475 22.2168 18.1562C21.8737 18.7594 21.3729 19.2326 20.7144 19.5757C20.0558 19.9132 19.2728 20.082 18.3652 20.082H15.3438V18.0732H17.9751C18.4565 18.0732 18.8605 17.9902 19.187 17.8242C19.519 17.6527 19.7653 17.4147 19.9258 17.1104C20.0863 16.806 20.1665 16.4491 20.1665 16.0396C20.1665 15.63 20.0863 15.2759 19.9258 14.9771C19.7653 14.6727 19.519 14.4403 19.187 14.2798C18.855 14.1138 18.4482 14.0308 17.9668 14.0308H16.2153V24H13.7251V11.9805Z"
					fill="white"
				/>
			</Svg>
		);
	}
);
PPTExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default PPTExtension;
